import { useSearchParams } from 'next/navigation'

import { isBrandCategoryMetas, isBrandMetas, isCategoryMetas, isCombinationMetas, isTagMetas } from './type-guards'
import { useBasicMetas } from './use-basic-metas'

import { usePLPFacetsContext } from '../facets-context/facets-context'
import { PLPPages } from '../types'

export function usePageTitle() {
    const searchParams = useSearchParams()
    const { page } = usePLPFacetsContext()
    const { basicMetas } = useBasicMetas()

    if (page === PLPPages.Search) {
        const query = searchParams.get('query')
        return query ? `نتایج جست‌وجو برای "${query}"` : 'نتایج جست‌وجو'
    }

    if (!basicMetas) return null

    switch (page) {
        case PLPPages.Brands:
            return isBrandMetas(page, basicMetas) ? basicMetas.nameFa || '' : ''

        case PLPPages.Categories:
            return isCategoryMetas(page, basicMetas) ? basicMetas.nameFa || '' : ''

        case PLPPages.Combination: {
            return isBrandCategoryMetas(page, basicMetas)
                ? `${basicMetas.category?.nameFa} ${basicMetas.brand?.nameFa}`
                : ''
        }
        case PLPPages.Tags:
            return isTagMetas(page, basicMetas) ? basicMetas.seoH1 || '' : ''
        case PLPPages.Facets:
        case PLPPages.BrandCategoriesCombination:
            return isCombinationMetas(page, basicMetas) ? basicMetas.seoH1 || '' : ''
    }
}
